import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import Button from "../../../../Button";

function View({ onSubmit, onClose, generalCost, upsells = [] }) {
  const { t } = useTranslation(NAME_SPACES.PUBLIC.ACORIS);
  const TRANSLATION = t("NAVBAR.CART", { returnObjects: true });
  const planName = get(generalCost, "insurancePlan.name") || "";
  const currency = get(generalCost, "currency");
  const currencySymbol = CURRENCY_SYMBOL[currency] || CURRENCY_SYMBOL.EUR;
  const monthlyAmount = upsells.reduce(
    (total, { cost }) => total + Number(cost || 0),
    Number(get(generalCost, "cost", 0)),
  );
  const annualAmount = (monthlyAmount * 12).toFixed(2);

  return (
    <div className="acoris-cart-modal">
      <div className="acoris-cart-modal__header">
        <h2 className="acoris-cart-modal__plan-name">{planName}</h2>
        <div className="acoris-cart-modal__price-section">
          <div className="acoris-cart-modal__price">
            <span className="acoris-cart-modal__price-value">
              {costToFrench(monthlyAmount)}
            </span>
            <span className="acoris-cart-modal__price-unit">
              <span className="acoris-cart-modal__price-currency">
                {currencySymbol}
              </span>
              <span className="acoris-cart-modal__price-period">
                {TRANSLATION.PER_MONTH}
              </span>
            </span>
          </div>
          <p className="acoris-cart-modal__price-annual">
            {TRANSLATION.ANNUAL.replace(
              "{amount}",
              costToFrench(annualAmount),
            ).replace("{currency}", currencySymbol)}
          </p>
        </div>
      </div>

      {upsells.length > 0 && (
        <div className="acoris-cart-modal__upsells">
          {upsells.map(
            ({ insurancePlan: { name }, cost, currency: upsellCurrency }) => {
              const upsellSymbol =
                CURRENCY_SYMBOL[upsellCurrency] || currencySymbol;
              return (
                <div className="acoris-cart-modal__upsell-item" key={name}>
                  <span className="acoris-cart-modal__upsell-name">{name}</span>
                  <span className="acoris-cart-modal__upsell-price">
                    <span className="acoris-cart-modal__upsell-amount">
                      + {costToFrench(cost)} {upsellSymbol}
                    </span>
                    <span className="acoris-cart-modal__upsell-period">
                      {TRANSLATION.PER_MONTH}
                    </span>
                  </span>
                </div>
              );
            },
          )}
        </div>
      )}

      <div className="acoris-cart-modal__actions">
        <Button
          type="primary-outlined"
          alignment="center"
          className="acoris-cart-modal__close"
          onClick={onClose}
        >
          {TRANSLATION.CLOSE}
        </Button>
        <Button
          type="primary"
          alignment="center"
          className="acoris-cart-modal__edit"
          onClick={onSubmit}
        >
          {TRANSLATION.EDIT}
        </Button>
      </div>
    </div>
  );
}

export default View;
